import { StyleSheet } from 'aphrodite';
import { SPACE } from '../../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	popup: {
		maxWidth: `calc(100vw - ${SPACE[32]}px)`,
		width: 660,
	},
});
